import { PlanSchema, type Plan } from "@roxpacer/core";

export function planFileName(plan: Plan): string {
  const slug = plan.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `${slug || "plan"}.roxpacer.json`;
}

export function downloadPlan(plan: Plan): void {
  const blob = new Blob([`${JSON.stringify(plan, null, 2)}\n`], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = planFileName(plan);
  link.click();
  URL.revokeObjectURL(url);
}

export type ParseResult = { ok: true; plan: Plan } | { ok: false; error: string };

export function parsePlanFile(text: string): ParseResult {
  let json: unknown;
  try {
    json = JSON.parse(text);
  } catch {
    return { ok: false, error: "That file isn't valid JSON." };
  }
  const result = PlanSchema.safeParse(json);
  if (!result.success) {
    const issue = result.error.issues[0];
    const where = issue && issue.path.length > 0 ? ` (${issue.path.join(".")})` : "";
    return { ok: false, error: `That file isn't a RoxPacer plan: ${issue?.message}${where}.` };
  }
  return { ok: true, plan: result.data };
}
